import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { useYupFields } from 'hooks/forms/useYupFields'

export enum ConvertWalletTarget {
  Self = 'self',
  Customer = 'customer',
}

export type ConvertDetailsForm = {
  fromWallet: string
  walletType: ConvertWalletTarget
  customerId: string
  toWallet: string
  fromAmount: string
  toAmount: string
  reference: string
}

export interface ConvertDetailsFormData extends ConvertDetailsForm {
  changedField: string
}

export type ConvertDetailsFormKeys = keyof ConvertDetailsForm

export const useConvertDetailsSchema = (t: TFunction<'translation', string>) => {
  const { getYupField, getRequiredYupField, getConditionalYupField } = useYupFields()

  return yup.object({
    fromWallet: getRequiredYupField({
      label: t('wallets.convert.convertFundsFrom'),
      requiredErrorMessage: t('wallets.convert.convertFromWalletRequired'),
    }),
    walletType: getRequiredYupField({
      label: '',
      requiredErrorMessage: t('wallets.convert.walletTypeRequired'),
    }),
    customerId: getConditionalYupField({
      label: t('wallets.convert.selectCustomer'),
      requiredErrorMessage: t('wallets.convert.selectCustomerRequired'),
      fieldKey: 'walletType',
      fieldValue: ConvertWalletTarget.Customer,
    }),
    toWallet: getRequiredYupField({
      label: t('wallets.convert.receiveFundsTo'),
      requiredErrorMessage: t('wallets.convert.convertToWalletRequired'),
    }),
    fromAmount: getYupField({
      label: t('wallets.convert.amountToConvert'),
    }),
    toAmount: getYupField({
      label: t('wallets.convert.amountToReceive'),
    }),
    reference: getYupField({
      label: t('formFields.uniqueReference'),
    }),
  })
}
